"use strict";
exports.__esModule = true;
exports.getTitleAndBody = void 0;
/**
 * This method returns title and body text according to the status of augmentation or transfer.
 * @param noStoryAdded Will be true if no story is added in the bot
 * @param isBaseUrlMissing Flag indicating if the base URL is missing
 * @param fetchingBotSummary Flag indicating if the bot summary call is in progress
 * @param isAugmentationInProgress Flag indicating if the augmentation process is in progress
 * @param botSummaryData bot summary data
 * @param isSuperman Flag indicating if the bot is superman bot or not

 */
function getTitleAndBody(noStoryAdded, isBaseUrlMissing, fetchingBotSummary, isAugmentationInProgress, botSummaryData, isSuperman) {
    if (fetchingBotSummary)
        return {
            title: 'Please Wait..',
            body: 'Fetching bot details.',
        };
    if (noStoryAdded)
        return {
            title: 'Publish Error..',
            body: 'No Skill Set to Publish',
        };
    if (isBaseUrlMissing)
        return {
            title: 'Publish Error..',
            body: 'You cannot publish without defining base URL for this Bot.',
        };
    if (isSuperman) {
        if (isAugmentationInProgress)
            return {
                title: "We're adding Smart Variants to your bot...",
                body: "We're adding new user messages to your bot. This usually takes a few minutes",
            };
        if (botSummaryData && botSummaryData.paraphraseSupported) {
            if (botSummaryData.paraphrasesCount > 0)
                return {
                    title: 'Ship a smarter bot with Smart Variants!',
                    body: "We found " + botSummaryData.paraphrasesCount + " instances where user messages can be added to your bot.\nClick on the \u2018Add Smart Variants\u2019 button below and wait for a few minutes. Then wait for the Publish button to be enabled and your new and improved bot is ready!",
                };
            return {
                title: "You're ready to Publish!",
                body: "You've already trained your IVA well. There are no more Smart Variants to add.\nGo ahead and click on ‘Publish Now’.",
            };
        }
    }
    return {
        title: 'Confirm Publish',
        body: 'Are you ready to see these changes go live?',
    };
}
exports.getTitleAndBody = getTitleAndBody;
;
